module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_6000.cfefcf57.png";